import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetProfilesMutation } from '../../../api/AdminProfileAPI';
import { PaginatorDto } from '../../eigeneauftraege/EigeneAuftraegeListe';
import PaginatorComponent from '../../eigeneauftraege/component/PaginatorComponent';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';

export default function ProfileMain() {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [getProfilesAPI] = useGetProfilesMutation();

  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [search, setSearch] = useState<string>("");

  const [liste, setListe] = useState<PaginatorDto>({ offset: 0, limit: 10, totalCount: 0, data: [] });
  const [isLoaded, setLoaded] = useState<boolean>(false);

  const ladeListe = () => {
    getProfilesAPI({
      offset: offset,
      limit: limit,
      search: search,
      sortBy: "",
      sortDirection: ""
    }).unwrap()
      .then(data => setListe(data))
      .then(() => setLoaded(true))
      .catch((e) => console.log(e))
  }

  const suche = (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();

    setOffset(0);
    ladeListe();
  }

  const pageChangeHandler = (page: number) => {
    setOffset(page * limit - limit);
  }

  // Load data when sort or offset changes
  useEffect(() => {
    // window.scrollTo(0, 0);
    ladeListe();
  }, [offset]);

  useEffect(() => {
    ladeListe();
  }, [getProfilesAPI]);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate({
                pathname: "/",
                search: ""
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          >
            <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>

          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Profile</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>
          <button className="btn btn-primary" onClick={() => navigate('detail', { state: { view: 'create' } })}><i className="bi bi-plus"></i><span style={{ marginLeft: "1em" }}>NEU ANLEGEN</span></button>

          <form onSubmit={suche} style={{ display: "flex", gap: "10px", alignItems: "center", margin: "40px 0px" }}>
            <div>
              Suche :
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <input type="text" className='form-control' placeholder='Suche' value={search} onChange={(e) => setSearch(e.target.value)} size={50} />
              <button type='submit' className="btn btn-primary">Suchen</button>
            </div>
          </form>

          <PaginatorComponent offset={offset} limit={limit} totalCount={liste.totalCount} pageChange={pageChangeHandler} />

          <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "2fr 3fr 1fr 1fr 40px", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
            <div>E-Mail</div>
            <div>Name</div>
            <div>2Phase</div>
            <div style={{ textAlign: "end" }}>
              Option
            </div>
          </div>
          {
            (isLoaded && liste?.data?.map((e, index) =>
              <div key={index}>
                <div key={index} style={{ display: "grid", gridTemplateColumns: "2fr 3fr 1fr 1fr 40px", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
                  <div>{e.email}</div>
                  <div>{e.name}</div>
                  <div>{e.is2fa ? "Ja" : "Nein"}</div>
                  <div style={{ textAlign: "end" }}>
                    <button onClick={() => navigate('detail', { state: { view: 'detail', id: e.uid } })} className={styles["wg-a"]} ><i className="bi bi-pencil"></i></button>
                  </div>
                </div>
              </div>)
            )
          }

          <PaginatorComponent offset={offset} limit={limit} totalCount={liste.totalCount} pageChange={pageChangeHandler} />

          {(!isLoaded && <>Lädt...</>)}

        </div>
      </div>

    </>
  );
}